/** Shared logo center text — keep in sync with public/brand/*.svg print files. */
export const SALONI_LOGO_TEXT = {
  script: {
    content: 'Saloni',
    x: 100,
    y: 96,
    fontFamily: "'Dancing Script', 'Segoe Script', cursive",
    fontSize: 30,
    fontWeight: 700,
    fill: '#9b3158',
  },
  serif: {
    content: 'Designs',
    x: 100,
    y: 118,
    fontFamily: "'Playfair Display', 'Cormorant Garamond', Georgia, serif",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: '0.04em',
    fill: '#5f7f68',
  },
};

export const SALONI_LOGO_CENTER = {
  coverRadius: 56,
  ringRadius: 55,
  ringStroke: '#e8b4c4',
  ringDash: '3.5 4.5',
};
